"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by vadimdez on 28/11/2016.
 */
var core_1 = require("@angular/core");
var ng2_filter_pipe_1 = require("./ng2-filter.pipe");
var Ng2FilterPipeModule = (function () {
    function Ng2FilterPipeModule() {
    }
    return Ng2FilterPipeModule;
}());
Ng2FilterPipeModule.decorators = [
    { type: core_1.NgModule, args: [{
                declarations: [ng2_filter_pipe_1.Ng2FilterPipe],
                exports: [ng2_filter_pipe_1.Ng2FilterPipe]
            },] },
];
/** @nocollapse */
Ng2FilterPipeModule.ctorParameters = function () { return []; };
exports.Ng2FilterPipeModule = Ng2FilterPipeModule;
//# sourceMappingURL=ng2-filter.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-filter-pipe/dist/src/ng2-filter.module.js
// module id = dVYu
// module chunks = 3